import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { CustomerOrderStatus } from "@/utils/enums";

type Props = {
    message?: string | null;
};

const DSVOrderItemStatus = ({ message }: Props) => {
    const { t } = useGranite();

    return (
        <>
            {!message &&
                t(`general.orderlinestatus.${CustomerOrderStatus.Created}`)}
            {message}
        </>
    );
};

export default DSVOrderItemStatus;
